import { EventType } from "../model/eventtype";

const normalizeEventType = (eventType: EventType | keyof typeof EventType | string | number): EventType | undefined => {
	if (typeof eventType === 'number') {
		return eventType as EventType;
	}

	if (typeof eventType === 'string') {
		const numericEventType = Number(eventType);

		if (!Number.isNaN(numericEventType)) {
			return numericEventType as EventType;
		}

		return EventType[eventType as keyof typeof EventType] as unknown as EventType;
	}

	return undefined;
};

export const mapEventTypeToImage = function (eventType: EventType | keyof typeof EventType | string | number) {
	const normalizedEventType = normalizeEventType(eventType);

	switch (normalizedEventType) {
		case EventType.NewDiaper:
		case EventType.ReuseDiaper:
			return "ok.svg";
		case EventType.DiaperFull:
			return "ful-wet.svg";
		case EventType.FirstUrine:
			return "wet-started.svg";
		case EventType.MaximumWearTime:
			return "max-time.svg";
		case EventType.BatteryLevel:
			return "low-battery.svg";
		case EventType.MaximumNoWearTime:
		case EventType.ChargingStarted:
		case EventType.ChargingFull:
		case EventType.LidOpen:
		case EventType.ChargingStopped:
			return "note.svg";
		case EventType.NoDataFromDevice:
		case EventType.NB_RSSILevel:
			return "nosignal.svg";
		case EventType.SensorSignalTooLow:
		case EventType.SensorSignalTooHigh:
		case EventType.SensorSignalGrass:
		case EventType.SensorSignalNotValid:
		case EventType.NB_SNRLevel:
		case EventType.NB_RSRPLevel:
			return "signalissue.svg";
		case EventType.DeviceTemperatureLow:
		case EventType.DeviceTemperatureHigh:
			return "temp.svg";
		case EventType.OutOfGeoPosition:
			return "geoloc.svg";
		case EventType.ConnectionReEstablished:
			return "reconnected.svg";
		default:
			return 'note.svg';
	}
}
